const MainMass = [
  // {
  //     id:1,
  //     title:"Стейк з тунця 200г/50г",
  //     isNew: true,
  //     price:"380 грн",
  //     src:require('../img/steyktun.png'),
  //     text:"тунець, соус з авокадо",
  // },

  {
    id: 2,
    title: 'Лосось в вершковому соусі 250г',
    price: '355 грн',
    src: require('../img/lososVershki.png'),
    text: 'філе лосося, помідори черрі,вершки, петрушка',
    isNew: true,
    allergy: `🐟лосось, 🥛молоко(вершки)`
  },
  {
    id: 3,
    title: 'Свинина з овочами 300г',
    price: '260 грн',
    src: require('../img/svinOvochi.png'),
    text: 'ошийок свинний,шампіньйони,болгарський перець,спаржа',
    isNew: true,
    allergy: `🍄‍🟫гриби,🌱соя`
  },
  // {
  //   id: 4,
  //   title: 'Ребра BBQ 350г/50г',
  //   price: '310 грн',
  //   src: require('../img/bbq.png'),
  //   text: 'Свинні ребра, соус BBQ, перець чілі',
  // },
  {
    id: 5,
    title: 'Тартар з лосося 250г',
    price: '360 грн',
    src: require('../img/tartartlosos.png'),
    text: 'Лосось, кунжут, цибуля, лимон, авокадо, перець солодкий, соевий соус, оливкове масло, багет',
    allergy: `🐟лосось, 🌱соя, 🌾глютен (багет),🌰кунжут,🍋цитрус`
  },
  // {
  //     id:6,
  //     title:"вафлі з беконом та яйцем 260г/50г",
  //     price:"165 грн",
  //     src:require('../img/solVafli.png'),
  //     text:"вафлі, яйце, бекон, перець болгарський, зелень, часниковий соус",
  // },
  {
    id: 7,
    title: 'стейк з лосося 150г/50г',
    price: '385 грн',
    src: require('../img/steykred.webp'),
    text: 'лосось, лимон, соус тар-тар',
    allergy: `🐟лосось,🍋цитрус`
  },
  {
    id: 8,
    title: 'грільчик 200/150/50',
    price: '295 грн',
    src: require('../img/steykkur.png'),
    text: 'Філе куряче,шампіньйони,болгарський перець,спаржа , соус медово-гірчичний',
    allergy: `🍄‍🟫гриби,🌱соя,🌶️гірчиця,🍯мед`
  },
  {
    id: 9,
    title: 'стейк зі свинини 200г/150г',
    price: '330 грн',
    src: require('../img/steykpig.png'),
    text: 'Свинина, смажена картопля, соус до мʼяса',
  },
  {
    id: 10,
    title: 'тигрові креветки на шпажках 140г/50г',
    price: '320 грн',
    src: require('../img/steykkrevetki.webp'),
    text: 'тигрові креветки, соус солодкий чілі, лимон',
    allergy: `🦐креветки ,🌱соя,🍋цитрус`
  },
];

export default MainMass;
